$(document).ready(function () {
	// Conserver l'existant : wrap des tables dans une div scrollable
	$("table").each(function () {
		if (!$(this).parent().hasClass("w-full")) {
			$(this).wrap('<div class="w-full overflow-scroll"></div>');
		}
	});
});

(function () {
	'use strict';

	// =========================================================
	// ISOLATION : marquer les tableaux de .poly-content avec `poly-table`
	// pour que le CSS <table> générique (page.css, ciblé en
	// `table:not(.poly-table) ...`) ne s'y applique pas -> ils gardent
	// leurs propres classes utilitaires (bg-[...], py-*, text-*, etc.).
	// Exécuté immédiatement (ce script est en fin de <body>) pour éviter
	// le flash de style avant DOMContentLoaded.
	// =========================================================
	(function markPolyTables() {
		var content = document.querySelector('.poly-content');
		if (!content) return;
		content.querySelectorAll('table').forEach(function (t) {
			t.classList.add('poly-table');
		});
	})();

	function init() {
		var content = document.querySelector('.poly-content');
		if (!content) return;

		// =========================================================
		// 1. NETTOYAGE : masquer le H2 "Sommaire" manuel s'il existe
		// =========================================================
		var manualToc = Array.from(content.querySelectorAll('h2')).find(function (h) {
			return /^\s*sommaire\s*$/i.test(h.textContent);
		});
		if (manualToc) {
			manualToc.classList.add('poly-hidden-summary');
			var sib = manualToc.nextElementSibling;
			while (sib && !/^H[1-6]$/.test(sib.tagName)) {
				sib.style.display = 'none';
				sib = sib.nextElementSibling;
			}
		}

		// =========================================================
		// 2. ENCARTS – auto-détection sur blockquote
		// =========================================================
		var TRIGGERS = {
			'astuce': 'poly-tip',
			'conseil': 'poly-tip',
			'conseil d\'expert': 'poly-tip',
			'tip': 'poly-tip',
			'attention': 'poly-warning',
			'warning': 'poly-warning',
			'avertissement': 'poly-warning',
			'focus': 'poly-focus',
			'à retenir': 'poly-focus',
			'a retenir': 'poly-focus',
			'le saviez-vous': 'poly-bon-savoir',
			'saviez-vous': 'poly-bon-savoir',
			'bon à savoir': 'poly-bon-savoir',
			'bon a savoir': 'poly-bon-savoir',
			'chiffres': 'poly-stats',
			'chiffres clés': 'poly-stats',
			'stats': 'poly-stats',
			'en chiffres': 'poly-stats'
		};
		content.querySelectorAll('blockquote').forEach(function (bq) {
			var first = bq.querySelector('strong, b');
			if (!first) return;
			var t = first.textContent.trim().toLowerCase().replace(/\s*[:.]\s*$/, '').trim();
			if (TRIGGERS[t]) bq.classList.add(TRIGGERS[t]);
		});

		// =========================================================
		// 3. FAQ – détection auto et transformation en accordéon
		// =========================================================
		var faqHeading = Array.from(content.querySelectorAll('h2')).find(function (h) {
			return /faq|questions?\s+fr[ée]quentes?/i.test(h.textContent);
		});
		if (faqHeading) {
			faqHeading.id = 'poly-faq';
			var sib2 = faqHeading.nextElementSibling;
			var nodesToRemove = [];
			var current = null;
			var faqList = document.createElement('div');
			faqList.className = 'poly-faq-list';

			while (sib2 && !/^H[12]$/.test(sib2.tagName)) {
				var isQuestion = sib2.tagName === 'H3' || sib2.tagName === 'H4';
				if (isQuestion) {
					if (current) faqList.appendChild(current);
					current = document.createElement('div');
					current.className = 'poly-faq-item';
					var btn = document.createElement('button');
					btn.type = 'button';
					btn.className = 'poly-faq-q';
					btn.textContent = sib2.textContent.trim();
					var ans = document.createElement('div');
					ans.className = 'poly-faq-a';
					current.appendChild(btn);
					current.appendChild(ans);
					(function (item) {
						btn.addEventListener('click', function () { item.classList.toggle('open'); });
					})(current);
				} else if (current) {
					var clone = sib2.cloneNode(true);
					current.querySelector('.poly-faq-a').appendChild(clone);
				}
				nodesToRemove.push(sib2);
				sib2 = sib2.nextElementSibling;
			}
			if (current) faqList.appendChild(current);

			if (faqList.children.length > 0) {
				faqHeading.parentNode.insertBefore(faqList, faqHeading.nextSibling);
				nodesToRemove.forEach(function (n) { n.remove(); });
				faqList.firstElementChild.classList.add('open');

				// Schema FAQPage
				var faqSchema = [];
				faqList.querySelectorAll('.poly-faq-item').forEach(function (item) {
					var q = item.querySelector('.poly-faq-q').textContent.trim();
					var a = item.querySelector('.poly-faq-a').textContent.trim().replace(/\s+/g, ' ');
					if (q && a) faqSchema.push({
						'@type': 'Question', name: q,
						acceptedAnswer: { '@type': 'Answer', text: a }
					});
				});
				if (faqSchema.length > 0) {
					var s = document.createElement('script');
					s.type = 'application/ld+json';
					s.textContent = JSON.stringify({
						'@context': 'https://schema.org',
						'@type': 'FAQPage',
						mainEntity: faqSchema
					});
					document.head.appendChild(s);
				}
			}
		}

		// =========================================================
		// 4. SOMMAIRE (TOC) – généré depuis les H2/H3 du contenu
		// =========================================================
		var tocList = document.getElementById('poly-toc-list');
		var tocAside = document.querySelector('.poly-toc-aside');
		if (tocList) {
			var headings = Array.from(content.querySelectorAll('h2:not(.poly-hidden-summary), h3'))
				.filter(function (h) { return !h.closest('#poly-related'); });

			var related = document.getElementById('poly-related');
			if (related) {
				headings.push(related);
			}

			if (headings.length === 0) {
				if (tocAside) tocAside.style.display = 'none';
			} else {
				headings.forEach(function (h, i) {
					if (!h.id) h.id = 'poly-h-' + i;
					var a = document.createElement('a');
					a.href = '#' + h.id;
					if (h === related) {
						a.textContent = "Tous les dispositifs d'investissement";
					} else {
						a.textContent = h.textContent.trim();
					}
					a.dataset.id = h.id;
					if (h.tagName === 'H3' || h === related) a.classList.add('poly-toc-h3');
					(function (target, link) {
						link.addEventListener('click', function (e) {
							e.preventDefault();
							var y = target.getBoundingClientRect().top + window.pageYOffset - 20;
							window.scrollTo({ top: y, behavior: 'smooth' });
							history.replaceState(null, '', '#' + target.id);
							tocList.querySelectorAll('a').forEach(function (el) {
								el.classList.toggle('active', el === link);
							});
						});
					})(h, a);
					tocList.appendChild(a);
				});

				// Scroll-spy : dernier heading dont le top a passé la ligne de référence
				var spyOffset = 140;
				var spy = function () {
					var sy = window.scrollY + spyOffset;
					var activeId = headings[0].id;
					var atBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 2);
					if (atBottom) {
						activeId = headings[headings.length - 1].id;
					} else {
						for (var i = 0; i < headings.length; i++) {
							if (headings[i].getBoundingClientRect().top + window.scrollY <= sy) {
								activeId = headings[i].id;
							} else {
								break;
							}
						}
					}
					tocList.querySelectorAll('a').forEach(function (a) {
						a.classList.toggle('active', a.dataset.id === activeId);
					});
				};
				window.addEventListener('scroll', spy, { passive: true });
				window.addEventListener('resize', spy);
				spy();
			}
		}

		// =========================================================
		// 5. BARRE DE PROGRESSION (basée sur le contenu)
		// =========================================================
		var bar = document.getElementById('poly-progress-bar');
		if (bar && content) {
			var update = function () {
				var rect = content.getBoundingClientRect();
				var start = window.scrollY + rect.top;
				var total = rect.height - window.innerHeight + 200;
				var scrolled = Math.max(0, window.scrollY - start + 100);
				var pct = total > 0 ? Math.min(100, (scrolled / total) * 100) : 0;
				bar.style.width = pct + '%';
			};
			window.addEventListener('scroll', update, { passive: true });
			window.addEventListener('resize', update);
			update();
		}

		// =========================================================
		// 6. TEMPS DE LECTURE – calculé sur le contenu
		// =========================================================
		var rtEl = document.getElementById('poly-readtime');
		if (rtEl) {
			var words = (content.textContent || '').trim().split(/\s+/).length;
			var mins = Math.max(1, Math.round(words / 230));
			rtEl.textContent = mins + ' min';
		}

		// =========================================================
		// 7. SHARE – copy link avec feedback (sans innerHTML)
		// =========================================================
		var copyBtn = document.getElementById('poly-copy');
		if (copyBtn && navigator.clipboard) {
			var origText = copyBtn.textContent;
			copyBtn.addEventListener('click', function () {
				navigator.clipboard.writeText(window.location.href).then(function () {
					copyBtn.classList.add('copied');
					copyBtn.textContent = '✓';
					setTimeout(function () {
						copyBtn.classList.remove('copied');
						copyBtn.textContent = origText;
					}, 2000);
				});
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
